import type { Conversation } from '@customTypes/chat';
import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type CreateConversationsParams = RequestConfig<{
  senderProfileId: string;
  recipientProfileId: string;
  topic?: string;
  isDirect?: boolean;
}>;

export const createConversation = async ({
  params,
  config
}: CreateConversationsParams) =>
  api.post<Conversation>('/api/chat/conversations', params, config);
